module.exports = __webpack_public_path__ + "static/media/AVeryBigFall.ab560732.jpg";